<template>
  <c-dialog v-model="isShow" :option="popOption" @close="$emit('close')">
    <template slot="body">
      <div :class="['dialog', 'dialog--default', !isMobile ? 'dialog--pc' : '']">
        <div class="dialog-content">
          <div class="purchase-body">
            <ul class="purchase-body-title" :style="purchaseRecordTitleBgStyle">
              <li class="purchase-body-title-goods-name" :style="purchaseRecordItemTitleCommonStyle">
                购买物品
              </li>
              <li class="purchase-body-title-time" :style="purchaseRecordItemTitleCommonStyle">
                购买时间
              </li>
              <li class="purchase-body-title-price" :style="purchaseRecordItemTitleCommonStyle">
                实消金额
              </li>
            </ul>
            <template v-if="showList.length > 0">
              <!--滚动窗口-->
              <div class="purchase-body-record-scroll-window" :style="purchaseRecordBodyRecordScrollStyle">
                <ul
                    class="purchase-body-record"
                    :style="purchaseRecordBottomBorderStyle"
                    v-for="(item, index) of showList"
                    :key="index"
                >
                  <li class="purchase-body-record-goods-name">
                    <span :style="purchaseRecordItemCommonStyle" v-if="item.GoodsName.length <= 13 && !isMobile">
                    {{ item.GoodsName}}</span>
                    <span :style="purchaseRecordItemCommonStyle" v-if="item.GoodsName.length <= 10 && isMobile">
                    {{ item.GoodsName}}</span>
                    <!-- 弹出层 -->
                    <div
                        ref="textDecorationPopupsPointer"
                        class="text-decoration-popups"
                        v-if="item.GoodsName.length > 10 && popupsIndex === index">
                      <div class="text-decoration-popups-pointer"></div>
                      <span ref="decorationPopupsText">{{ item.GoodsName }}</span>
                    </div>
                    <span :style="purchaseRecordItemCommonStyle" v-if="item.GoodsName.length > 13 && !isMobile"
                          class="text-decoration text-weight"
                          @click="showDetail(item.GoodsName, index)">
                      {{ item.GoodsName }}
                    </span>
                    <span :style="purchaseRecordItemCommonStyle" v-if="item.GoodsName.length > 10 && isMobile"
                          class="text-decoration text-weight"
                          @click="showDetail(item.GoodsName, index)">
                      {{ item.GoodsName }}
                    </span>
                  </li>
                  <li
                      class="purchase-body-record-time"
                      :style="purchaseRecordItemTimeStyle"
                  >
                    {{ getTime(item) }}
                  </li>
                  <li
                      class="purchase-body-record-price"
                      :style="purchaseRecordItemCommonStyle"
                  >
                    {{ item.RealPay / 100 }}元
                  </li>
                </ul>
              </div>
            </template>
            <template v-if="showList.length === 0">
              <div class="purchase-body-empty-record-msg" :style="purchaseRecordItemCommonStyle">
                没有购买记录，快去参加活动吧
              </div>
            </template>
            <template v-if="showList.length > 0">
              <div class="purchase-body-page" v-if="Math.ceil(page.total / pageSize) >= 1">
                <span @click="page.current > 1 && page.current--" :style="pageSizeItemCommonStyle">上一页</span>
                <span class="purchase-body-page-num" :style="pageSizeItemCommonStyle">
                  {{ page.current }}/{{ Math.ceil(page.total / pageSize) }}</span>
                <span @click="page.current < page.total / pageSize && page.current++"
                      :style="pageSizeItemCommonStyle">下一页</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </c-dialog>
</template>

<script>
import CDialog from '../ceiba-dialog';
import common from '../../common';
import Vue from 'vue';

const SELL_CHANNEL_MAP = {
  tgclub: '1',
  supercore: '4',
};

const DEFAULT_PAY_BUSINESS = 'act';

export default {
  name: 'recharge-record',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    thisFlowRequest: Function,
    myRoleInfo: Object,
    payBusiness: String, // 支付流水归属
    sellChannel: String, // 销售渠道
    flowId: String, // 查询条件ID
    // 查询中台还是老支付
    upBiz: {
      type: Boolean,
      default: false,
    },
    option: Object,
    pageSize: Number, // 每页展示数
    spInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      list: [],
      showList: [],
      page: {
        current: 1,
        total: 0,
      },
      isShow: true,
      popupsIndex: -1, // 弹出层下标
    };
  },
  computed: {
    popOption() {
      // 用户配置
      console.log('---  user  setting  popConfig ---- ', this.option);
      // 读取传入width, height
      const { titleStyle = {}, dialogStyle: dialogStyleOption = {}, width, height } = this.option || {};
      // 新增标题颜色
      if (!titleStyle.color) {
        titleStyle.color = this.titleTextStyle?.color;
      }
      // eslint-disable-next-line max-len, vue/max-len
      const { dialogStyle = {}, closeLocation } = Vue.prototype?.$storeInstance?.getters?.dialogConfig ?? {};
      let { closeStyle = {} } = Vue.prototype?.$storeInstance?.getters?.dialogConfig ?? {};
      let bgImageStyle = '';
      const bgImageReg = /(https:|http:)?\/\/[^\s]*$/;
      if (!bgImageStyle && dialogStyleOption.backgroundImage && bgImageReg.test(dialogStyleOption.backgroundImage)) {
        bgImageStyle = dialogStyleOption.backgroundImage;
      }
      if (!bgImageStyle && dialogStyle.backgroundImage && bgImageReg.test(dialogStyle.backgroundImage)) {
        bgImageStyle = dialogStyle.backgroundImage;
      }
      if (!closeStyle.backgroundImage || !bgImageReg.test(closeStyle.backgroundImage)) {
        closeStyle = '';
      }
      let dlgHeader = '购买记录';
      if (!!this.option.header) {
        dlgHeader = this.option.header;
      }
      const popConfig = {
        header: dlgHeader,
        titleStyle: { fontSize: '0.36rem', borderBottom: 'none', fontWeight: 600, ...titleStyle },
        close: true,
        closeLocation: !this.isMobile ? 'top-right' : closeLocation,
        height,
        width,
        confirm: false,
        footer: false,
        closeStyle: !this.isMobile ? {
          backgroundImage: 'url(https://act.supercore.qq.com/activity/supercore/14161/be052f80d9bba6a5888eb12b6b045ffa.png)',
        } : closeStyle,
        dialogStyle: Object.assign(
          {},
          {
            color: this.popTextStyle.color,
            backgroundImage: bgImageStyle,
          },
        ),
      };
      // 设置默认的width, height
      if (!popConfig.width) {
        popConfig.width = '6rem';
      }
      if (!popConfig.height) {
        popConfig.height = '6rem';
      }
      // 如果传入高度低于  6rem 则强制用 6rem
      if (parseFloat(popConfig.height) < 6) {
        popConfig.height = '6rem';
      }
      console.log('--------------------  final reward window popConfig  ------------= ', popConfig);
      return popConfig;
    },
    popTextStyle() {
      const { dialogStyle = {} } = this.option;
      let color = dialogStyle?.color;
      if (!color) {
        color = Vue.prototype?.$storeInstance?.getters?.dialogConfig?.dialogStyle?.color || '#ffffff';
      }
      return { color };
    },
    popStyleTextRgba() {
      const hexToRgba = (hex, opacity) => `rgba(${parseInt(`0x${hex.slice(1, 3)}`, 16)}
      ,${parseInt(`0x${hex.slice(3, 5)}`, 16)},${parseInt(`0x${hex.slice(5, 7)}`, 16)},${opacity})`;
      return {
        color100: this.popTextStyle.color,
        color50: hexToRgba(this.popTextStyle.color, 0.5),
        color80: hexToRgba(this.popTextStyle.color, 0.8),
        color10: hexToRgba(this.popTextStyle.color, 0.10),
      };
    },
    purchaseRecordTitleBgStyle() {
      return { backgroundColor: !this.isMobile ? '#F7F9FA' : this.popStyleTextRgba.color10 };
    },
    purchaseRecordItemTitleCommonStyle() {
      return {
        color: !this.isMobile ? '#242424' : this.popStyleTextRgba.color50,
      };
    },
    purchaseRecordItemCommonStyle() {
      return {
        color: !this.isMobile ? '#242424' : this.popStyleTextRgba.color100,
        '--empty-top-height': '33%',
      };
    },
    purchaseRecordBodyRecordScrollStyle() {
      const overflow = !this.isMobile ? 'visible' : 'hidden';
      return {
        overflowY: this.list.length <= 6 ? overflow : 'scroll',
        '--dynamic-height': '3.64rem',
      };
    },
    purchaseRecordBottomBorderStyle() {
      return {
        // borderBottom: `${!this.isMobile
        //   ? '0px' : '0.02rem'} solid ${this.popStyleTextRgba.color10}`,
      };
    },
    purchaseRecordItemTimeStyle() {
      return {
        color: !this.isMobile ? '#242424' : this.popStyleTextRgba.color100,
      };
    },
    pageSizeItemCommonStyle() {
      return {
        color: !this.isMobile ? '#8E8E93' : this.popStyleTextRgba.color50,
      };
    },
  },
  watch: {
    'page.current'() {
      this.freshList();
    },
  },
  async mounted() {
    this.getRechargeRecordList();
  },
  methods: {
    getTime(item) {
      return common.tool.toDateTimeString(new Date(item.CreateAt * 1000));
    },

    async freshList() {
      if (this.upBiz === true) {
        this.getRechargeRecordList();
        return;
      }
      this.showList = this.list.slice(
        (this.page.current - 1) * this.pageSize,
        (this.page.current - 1) * this.pageSize + this.pageSize,
      );
    },

    async getRechargeRecordList() {
      const sellScene = `ceiba_act_${this.$actInfo.activity_id}`;
      if (this.upBiz === true) {
        const postData = {
          business: this.payBusiness || DEFAULT_PAY_BUSINESS,
          sell_scene: sellScene,
          page_size: this.pageSize,
          page_index: this.page.current,
          sell_channel: this.sellChannel,
          role: this.myRoleInfo,
          query_status: [3, 4, 8, 9, 11],
        };
        const response = await this.$requestInstance.post('/action/api/common/v2/centralQueryOrders', postData);
        if (response.ret) {
          this.$alert({
            msg: '网络繁忙',
          });
          return false;
        }
        this.page.total = response.data?.total;
        const tempOrderList = [];
        response.data?.infoList?.forEach((order) => {
          tempOrderList.push({
            OrderId: order.order_id,
            CreateAt: new Date(order.created_at).getTime() / 1000,
            RealPay: order.payment_result?.pay_money,
            GoodsName: order.attached_info?.sku_name,
          });
        });
        this.showList = tempOrderList;
        return;
      }
      const response = await this.thisFlowRequest({
        flowId: this.flowId,
        params: {
          role: this.myRoleInfo,
          sell_channel: this.sellChannel || SELL_CHANNEL_MAP[this.$actInfo.ast],
          data: JSON.stringify({
            role: this.myRoleInfo,
            payInfo: {
              business: this.payBusiness || DEFAULT_PAY_BUSINESS,
              sell_channel: this.sellChannel || SELL_CHANNEL_MAP[this.$actInfo.ast],
              platform: common.platform.isAndroid ? 'android' : 'ios',
              role: this.myRoleInfo,
              path_through: '',
              channel: 'h5', // 先写死h5
              sell_scene: sellScene,
              sp_info: this.spInfo, // midas券信息
            },
          }),
        },
      });
      const { ret, msg, data } = response;
      const { ret: dataRet, data: dataData } = data;
      if (ret !== 0 || dataRet !== 0) {
        this.$alert({ msg: msg || '网络繁忙' });
        return false;
      }
      this.page.total = dataData.length;
      this.list = dataData;
      this.showList = dataData.slice(
        (this.page.current - 1) * this.pageSize,
        (this.page.current - 1) * this.pageSize + this.pageSize,
      );
      this.freshList();
    },
    showDetail(goodsName, index) {
      if (!this.isMobile) {
        this.popupsIndex = index;
        const that = this;
        this.$nextTick(() => {
          const [decorationPopups] = that.$refs.textDecorationPopupsPointer;
          decorationPopups.setAttribute('style', 'width: 220px');
        });
      } else {
        this.alert(goodsName);
      }
    },
  },
};
</script>

<style scoped>
.dialog {
  font-size: 0.2rem;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 6rem;
  position: relative;
}

.dialog--pc {
  font-size: 20px;
  width: 600px;
  display: block;
  height: 100%;
  position: static;
}

.dialog-content {
  text-align: center;
  margin: 0 auto;
}

.dialog--default .purchase-body {
  width: 5.6rem;
  height: 4.84rem;
}

.dialog--default .purchase-body-title {
  width: 5.6rem;
  height: 0.5rem;
  line-height: 0.5rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  text-align: center;
  border-radius: 0.1rem;
}

.dialog--default .purchase-body-title .purchase-body-title-goods-name {
  padding-left: 0.2rem;
  width: 2.1rem;
}

.dialog--default .purchase-body-title .purchase-body-title-time {
  padding-left: 0.1rem;
  width: 2.2rem;
}

.dialog--default .purchase-body-title .purchase-body-title-price {
  padding-left: 0.2rem;
  width: 1.3rem;
}

.dialog--default .purchase-body-record .purchase-body-record-goods-name {
  padding-left: 0.2rem;
  width: 2.1rem;
}

.dialog--default .purchase-body-record .purchase-body-record-time {
  width: 2.2rem;
  padding-left: 0.1rem;
  font-size: 0.2rem;
}

.dialog--default .purchase-body-record .purchase-body-record-price {
  padding-left: 0.2rem;
  width: 1.3rem;
}

.dialog--default .purchase-body-title li {
  font-size: 0.2rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  text-align: left;
}

.purchase-body-record .text-decoration {
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 1.8rem;
}
.purchase-body-record .text-weight {
  font-weight: 600;
}


.purchase-body-record-scroll-window {
  /* 高度 (0.65 + 0.02（边框） ) *  6 */
  height: var(--dynamic-height);
  max-height: var(--dynamic-height);
  margin-top: 0.16rem;
}

.dialog--default .purchase-body-record {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  justify-content: flex-start;
}

.dialog--default .purchase-body-record li {
  width: 5.6rem;
  height: 0.48rem;
  line-height: 0.48rem;
  font-size: 0.2rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  text-align: center;
  list-style: none;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dialog--default .purchase-body-empty-record-msg {
  letter-spacing: 1px;
  font-size: 0.2rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
  margin: var(--empty-top-height) auto 0;
}

.dialog--default .purchase-body-page {
  font-size: 0.2rem;
  font-weight: 400;
  font-family: 'FZLanTingHei-R-GBK';
  font-style: normal;
}

.dialog--default .purchase-body-page .purchase-body-page-num {
  margin: 0 0.7rem;
}

.purchase-body-record-time {
  white-space: nowrap;
}

/* pc */
.dialog--pc .purchase-body {
  width: 100%;
  height: 100%;
  padding: 0 24px;
}

.dialog--pc .purchase-body-title {
  width: 100%;
  height: 50px;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  list-style: none;
  text-align: center;
  border-radius: 6px;
}

.dialog--pc .purchase-body-title li {
  font-style: normal;
  line-height: 50px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0px;
  text-align: left;
}

.dialog--pc .purchase-body-record {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;
  margin: 12px 0;
}

.dialog--pc .purchase-body-title .purchase-body-title-goods-name {
  margin-left: 20px;
  width: 210px;
}

.dialog--pc .purchase-body-title .purchase-body-title-time {
  margin-left: 10px;
  width: 220px;
}

.dialog--pc .purchase-body-title .purchase-body-title-price {
  margin-left: 20px;
  width: 130px;
}

.dialog--pc .purchase-body-record .purchase-body-record-goods-name {
  margin-left: 20px;
  width: 210px;
  position: relative;
  display: inline-block;
}

.dialog--pc .purchase-body-record .purchase-body-record-time {
  margin-left: 10px;
  font-size: 14px;
  width: 220px;
}

.dialog--pc .purchase-body-record .purchase-body-record-price {
  margin-left: 20px;
  width: 130px;
}

.dialog--pc .win-prize-body-record .text-decoration {
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 135px;
  color: #1D3F7C;
  font-weight: 600;
}
.dialog--pc .win-prize-body-record .text-weight {
  font-weight: 600;
}

.dialog--pc .text-decoration-popups {
  width: 1366px;
  max-width: 452px;
  max-height: 100px;
  min-width: 200px;
  background-color: #000;
  padding: 5px 10px;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  border-radius: 15px;
  bottom: 35px;
  z-index: 99;
  animation: pop-open 0.3s 1;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
  box-sizing: content-box;
  display: inline-block;
}

.dialog--pc .text-decoration-popups-pointer {
  position: absolute;

  width: 0px;
  height: 0px;
  border: 9px solid transparent;
  /* border: 18px solid rgba(0,0,0,0.7); */
  border-bottom-color: transparent;
  border-top-color: rgba(0, 0, 0, 0.6);
  border-left-color: transparent;
  border-right-color: transparent;
  bottom: -18px;
  left: 80px;
  transform: translateX(-50%);
}

.dialog--pc .text-decoration-popups p {
  /* max-width: 452px;
  min-width: 200px;
  max-height: 100px; */
  width: fit-content;
  display: block;
  /* height: 100px; */
  color: #fff;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  z-index: 99;
}

.dialog--pc .purchase-body-empty-record-msg {
  letter-spacing: 1px;
  font-family: PingFang SC;
  font-style: normal;
  font-size: 14px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: center;
  margin: 29% auto;
}

.dialog--pc .purchase-body-record li {
  width: 560px;
  height: 32px;
  line-height: 32px;
  font-weight: 400;
  font-family: PingFang SC;
  font-style: normal;
  text-align: left;
  list-style: none;
  font-family: PingFang SC;
  font-size: 14px;
  letter-spacing: 0px;
  text-align: left;
}

.dialog--pc .purchase-body-record-scroll-window {
  /* 高度 (0.65 + 0.02（边框） ) *  6 */
  height: 364px;
  border-bottom: 1px solid #EBEBEB;
  padding-bottom: 12px;
  max-height: 364px;
}

.dialog--pc .purchase-body-page {
  font-size: 14px;
  font-weight: 400;
  font-family: PingFang SC;
  font-style: normal;
  margin: 20px 0;
}

.dialog--pc .purchase-body-page .purchase-body-page-num {
  margin: 0 70px;
}

@keyframes pop-open {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes pop-close {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

</style>
